import { Img } from 'react-image'
import LazyLoad from 'react-lazyload'
import Spinner from './Spinner'
import classNames from 'classnames'
import styles from '../styles/CardImage.module.scss'
import { v4 } from 'uuid'

const MySpinner = () => (
  <div className={styles.spinnerContainer}>
    <Spinner className={styles.spinner} />
  </div>
)

const CardImage = ({ height, isLoading, isNew, srcs, name }) =>
  isLoading ? (
    <MySpinner />
  ) : (
    <LazyLoad
      className={styles.image}
      height={height}
      offset={500}
      once
      placeholder={<MySpinner />}
    >
      {/* 
      accounts for partners and flip cards
      all images get styles.image (unless it's Mind Flayer) & shadow
      if more than one image src comes in, first gets image.front, second gets image.back 
      */}
      {srcs.map((src, i, arr) => (
        <Img
          className={classNames(
            name === 'Mind Flayer, the Shadow' ? styles.image180 : styles.image,
            arr.length > 1
              ? i === 0
                ? styles.imageFront
                : styles.imageBack
              : null,
            'shadow'
          )}
          key={v4()}
          loader={<MySpinner />}
          src={src}
        />
      ))}
      {isNew && <div className={styles.new}>NEW</div>}
    </LazyLoad>
  )

export default CardImage
